import { cn } from '@avanta/shared/utils/cn';

const MOBILE_RING = {
  radius: 13,
  sizeClass: 'size-8',
  viewBox: '0 0 32 32',
  center: 16,
  strokeWidth: 3,
} as const;

const DESKTOP_RING = {
  radius: 20,
  sizeClass: 'size-12',
  viewBox: '0 0 48 48',
  center: 24,
  strokeWidth: 3,
} as const;

const RINGS = {
  mobile: MOBILE_RING,
  desktop: DESKTOP_RING,
} as const;

const getRingStroke = (
  radius: number,
  progress: number
): { strokeDasharray: number; strokeDashoffset: number } => {
  const circumference = 2 * Math.PI * radius;
  return {
    strokeDasharray: circumference,
    strokeDashoffset: circumference * (1 - progress),
  };
};

interface ProgressRingProps {
  variant: keyof typeof RINGS;
  progress: number;
  color: string;
}

export const ProgressRing = ({
  variant,
  progress,
  color,
}: ProgressRingProps): React.ReactElement => {
  const ring = RINGS[variant];
  const { strokeDasharray, strokeDashoffset } = getRingStroke(ring.radius, progress);

  return (
    <svg className={cn(ring.sizeClass, 'shrink-0 -rotate-90')} viewBox={ring.viewBox} aria-hidden>
      <circle
        cx={ring.center}
        cy={ring.center}
        r={ring.radius}
        stroke="var(--color-plum-200)"
        strokeWidth={ring.strokeWidth}
        fill="none"
      />
      <circle
        cx={ring.center}
        cy={ring.center}
        r={ring.radius}
        stroke={color}
        strokeWidth={ring.strokeWidth}
        fill="none"
        strokeLinecap="round"
        strokeDasharray={strokeDasharray}
        strokeDashoffset={strokeDashoffset}
      />
    </svg>
  );
};
